export const TOOLTIP_URLS = {
  GET_ALL_TOOLTIP_PAGES: '/tooltip/pages',
  GET_ALL_TOOLTIP_INPUTS: '/tooltip/admin',
  UPDATE_TOOLTIP_INPUTS: '/tooltip'
};
